import { useCallback, useState } from "react";
import { randomId } from "../utils/randomId.ts";

const STORAGE_KEY = "ai_session_id";

export function useSessionId(): [string, () => string] {
  const [sessionId, setSessionId] = useState<string>(() => {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const id = randomId();
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  });

  const resetSessionId = useCallback(() => {
    const id = randomId();
    localStorage.setItem(STORAGE_KEY, id);
    setSessionId(id);
    return id;
  }, []);

  return [sessionId, resetSessionId];
}
